/**
 * CNESInfoCard Component - Information card about CNES
 */
import React from 'react';

export const CNESInfoCard: React.FC = () => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
      <h3 className="text-lg font-semibold text-blue-900 mb-2">
        ℹ️ Sobre o CNES
      </h3>
      <p className="text-blue-800 mb-4">
        O Cadastro Nacional de Estabelecimentos de Saúde (CNES) é o sistema de informação
        oficial de cadastramento de informações de todos os estabelecimentos de saúde no país,
        independentemente de sua natureza jurídica ou de integrarem o Sistema Único de Saúde (SUS).
      </p>
      <div className="grid md:grid-cols-2 gap-4 text-sm text-blue-800">
        <div>
          <strong>Base de Dados:</strong> Hospitais cadastrados no sistema local
        </div>
        <div>
          <strong>Filtros disponíveis:</strong> Nome, Estado, Cidade, CNES
        </div>
      </div>
    </div>
  );
};
